import React from "react";
import firebase from "firebase.config";
import WYSIWYGEditor from "components/WYSIWYGEditor";

export default class Page5 extends React.Component {
  state = {
    update: true,
    enable: true,
    title: "",

    header: [
      {
        image: null,
        title: "",
        buttons: [
          {
            image: null,
            title: "",
            htmlData: ""
          }
        ]
      }
    ]
  };

  // ----- Tailwind 공통 입력 스타일 -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  constructor(props) {
    super(props);

    let header = this.state.header;
    header[0] = this.props.obj[0];

    let temp = this.props.title;

    this.state = {
      header: header,
      title: temp,
      update: true,
      temp: "Hi"
    };
  }

  componentDidMount = () => {};

  componentDidUpdate = () => {
    if (this.state.update) {
      this.initialize();

      this.setState({
        update: false
      });
    }
  };

  initialize = () => {
    let header = this.state.header;
    header[0] = this.props.obj[0];

    let temp = this.props.title;

    this.setState({
      header: header,
      title: temp
    });
  };

  addMainImage = async event => {
    var temp = this.state.header;
    temp[0].image = event.target.files[0];

    this.setState({
      data: temp
    });

    console.log("Image To Be Uploaded!");

    await this.saveMainImage();
  };

  saveMainImage = async () => {
    let temp = this.state.header;
    let file = temp[0].image;

    if (file) {
      var min = 1;
      var max = 100;
      var rand = min + Math.random() * (max - min);

      var filename = "page5" + "+" + rand;

      const storage = firebase.storage().ref();
      const image = storage.child(filename);

      await image.put(file).then(async snapshot => {
        await image.getDownloadURL().then(async url => {
          console.log(url);
          temp[0].image = url;
          this.setState({
            magazineObj: temp
          });
        });
      });
    }
    console.log("Image Uploaded!!!");
  };

  addBgImage = async (event, index) => {
    var temp = this.state.header;
    temp[0].buttons[index].image = event.target.files[0];

    this.setState({
      data: temp
    });

    console.log("Image To Be Uploaded!");

    await this.saveBgImages(index);
  };

  saveBgImages = async index => {
    let temp = this.state.header;
    let file = temp[0].buttons[index].image;

    if (file) {
      var min = 1;
      var max = 100;
      var rand = min + Math.random() * (max - min);

      var filename = "page5" + "+" + index + "+" + rand;

      const storage = firebase.storage().ref();
      const image = storage.child(filename);

      await image.put(file).then(async snapshot => {
        await image.getDownloadURL().then(async url => {
          console.log(url);
          temp[0].buttons[index].image = url;
          this.setState({
            header: temp
          });
        });
      });
    }
    console.log("Image Uploaded!!!");
  };

  addHeader = () => {
    this.props.onAddHeader();
  };

  handleTitleChange = (event, index) => {
    this.props.onHandleTitleChange(event.target.value, index);
  };

  handleEditorChange = (event, index) => {
    this.props.onHandleEditorChange(event.target.value, index);
  };

  handleEditorUpdate = (val, index) => {
    this.props.onHandleEditorUpdate(val, index);
  };

  myFunc = index => {
    return (
      <WYSIWYGEditor
        editorId="pageContent"
        onChange={event => {
          this.handleEditorChange(event, index);
        }}
        updateValues={val => {
          this.handleEditorUpdate(val, index);
        }}
        description="Enter subpage content"
      />
    );
  };

  deleteRow = index => {
    let data = this.state.header;
    data[0].buttons.splice(index, 1);
    this.setState({
      header: data
    });
  };

  render() {
    return (
      <div className="content">
        <div className="mx-auto w-full max-w-3xl px-2">
          {/* 페이지 5 메인 */}
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                5
              </span>
              <h3 className="text-lg font-bold text-gray-800">
                추가 페이지 내용
              </h3>
            </div>

            <div className="space-y-4">
              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  페이지 제목
                </label>
                <input
                  type="text"
                  placeholder="예) 더 보기"
                  defaultValue={this.state.title}
                  className={this.inputCls + " sm:max-w-xs"}
                  onChange={event => {
                    this.setState({ title: event.target.value }, () => {
                      this.props.onTitleChange(this.state.title);
                    });
                  }}
                />
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  대표 이미지
                </label>
                <div className="flex flex-col items-start gap-4 rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 p-4 sm:flex-row sm:items-center">
                  <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg bg-sky-500 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-600">
                    🖼️ 이미지 선택
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={event => this.addMainImage(event)}
                    />
                  </label>
                  {this.state.header[0].image && (
                    <img
                      src={this.state.header[0].image}
                      alt="미리보기"
                      className="h-20 w-20 rounded-lg object-cover shadow"
                    />
                  )}
                </div>
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  제목
                </label>
                <input
                  type="text"
                  placeholder="예) 안내"
                  defaultValue={this.state.header[0].title}
                  className={this.inputCls}
                  onChange={event => {
                    let header = this.state.header;
                    header[0].title = event.target.value;
                    this.setState({
                      magazine: header
                    });
                  }}
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <button
                type="button"
                className="inline-flex items-center gap-1 rounded-xl bg-sky-500 px-5 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600"
                onClick={() => this.addHeader()}
              >
                + 서브 페이지 추가
              </button>
            </div>
          </section>

          {/* 서브 페이지 목록 */}
          {this.state.header[0].buttons.map((table, index) => (
            <section
              key={index}
              className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm"
            >
              <div className="mb-4 flex items-center justify-between">
                <span className="rounded-md bg-sky-500 px-2 py-0.5 text-xs font-bold text-white">
                  서브 페이지 {index + 1}
                </span>
                <button
                  type="button"
                  className="inline-flex items-center gap-1 rounded-lg border border-rose-200 bg-white px-3 py-1.5 text-xs font-medium text-rose-500 transition hover:bg-rose-50"
                  onClick={() => this.deleteRow(index)}
                >
                  🗑️ 삭제
                </button>
              </div>

              <div className="space-y-4">
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <label className="mb-1 block text-xs font-semibold text-gray-600">
                      이미지
                    </label>
                    <div className="flex items-center gap-3 rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 p-3">
                      <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg bg-sky-500 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-sky-600">
                        선택
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={event => this.addBgImage(event, index)}
                        />
                      </label>
                      {table.image && (
                        <img
                          src={table.image}
                          alt=""
                          className="h-12 w-12 rounded-lg object-cover shadow"
                        />
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="mb-1 block text-xs font-semibold text-gray-600">
                      제목
                    </label>
                    <input
                      type="text"
                      placeholder="제목을 입력하세요"
                      defaultValue={table.title}
                      className={this.inputCls}
                      onChange={event => this.handleTitleChange(event, index)}
                    />
                  </div>
                </div>

                <div>
                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    내용
                  </label>
                  <div className="rounded-lg border border-gray-200 p-1">
                    <WYSIWYGEditor
                      editorId="pageContent"
                      onChange={event => {
                        console.warn(event);
                        this.handleEditorChange(event, index);
                      }}
                      updateValues={val => {
                        console.warn(val);
                        this.handleEditorUpdate(val, index);
                      }}
                      defaultValue={table.htmlData ? table.htmlData : ""}
                      description="내용을 입력하세요"
                    />
                  </div>
                </div>
              </div>
            </section>
          ))}
        </div>
      </div>
    );
  }
}
